import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TicketsPage } from '@/features/admin/tickets/tickets-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Support : tickets du tenant (porting README #90). */
export const Route = createFileRoute('/$tenant/support/')({ component: TicketsRoute });

function TicketsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="tickets" crumbs={[{ label: t('nav.items.tickets') }]}>
      <TicketsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
